import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ index, label }) => (
  <div className="flex items-center gap-3 mb-6" data-testid={`section-tag-${index}`}>
    <span className="h-px w-10 bg-mission" />
    <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-polar">
      {index} / {label}
    </span>
  </div>
);
